import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarButton as t } from "../../components/content-controls/toolbar-button.mjs";
import { UrlInput as n } from "../../components/url-input.mjs";
import { ToolbarPopover as r } from "../../components/content-controls/toolbar-popover.mjs";
import { useState as i } from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { isValidUrl as s } from "@systemeio/util";
import { CheckIcon as c, ChevronDownIcon as l, Image01Icon as u } from "@systemeio/icons";
//#region src/extensions/image-extension/insert-image-via-link.tsx
function d({ asSheetRow: t = !1, isDisabled: n, handleSetImage: i }) {
	let { t: o } = e();
	return /* @__PURE__ */ a(r, {
		asSheetRow: t,
		disabled: n,
		icon: /* @__PURE__ */ a(u, {}),
		label: o("image_via_link"),
		popupClassName: "p-3",
		size: "icon-xs",
		triggerContent: /* @__PURE__ */ a(l, { className: "transition-base data-popup-open:rotate-180" }),
		children: /* @__PURE__ */ a(f, {
			handleSetImage: i,
			isDisabled: n
		})
	});
}
function f({ handleSetImage: r, isDisabled: l }) {
	let { t: u } = e(), [d, f] = i(""), p = l || !d || !s(d);
	return /* @__PURE__ */ o("form", {
		className: "flex items-end gap-1",
		onSubmit: (e) => e.preventDefault(),
		children: [/* @__PURE__ */ a(n, {
			className: "w-64",
			disabled: l,
			label: u("image_insert_via_link"),
			onChange: f,
			placeholder: "example.com/image.png",
			value: d
		}), /* @__PURE__ */ a(t, {
			disabled: p,
			label: u("global.apply"),
			onClick: () => r(d),
			type: "submit",
			children: /* @__PURE__ */ a(c, {})
		})]
	});
}
//#endregion
export { d as InsertImageViaLink };
